import { ReactNode } from 'react';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { RouteKeys } from 'src/routes/route-keys';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import StoreIcon from '@mui/icons-material/Store';
import PlaceIcon from '@mui/icons-material/Place';
import SchemaIcon from '@mui/icons-material/Schema';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import TableViewIcon from '@mui/icons-material/TableView';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import InsightsIcon from '@mui/icons-material/Insights';
import TodayIcon from '@mui/icons-material/Today';
import BlockIcon from '@mui/icons-material/Block';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import GradingIcon from '@mui/icons-material/Grading';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DvrIcon from '@mui/icons-material/Dvr';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import AddToQueueIcon from '@mui/icons-material/AddToQueue';
import RedeemIcon from '@mui/icons-material/Redeem';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import CategoryIcon from '@mui/icons-material/Category';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import EditLocationIcon from '@mui/icons-material/EditLocation';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import VehicleIcon from '@mui/icons-material/DirectionsCar';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import BallotIcon from '@mui/icons-material/Ballot';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PolicyIcon from '@mui/icons-material/Policy';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import HelpIcon from '@mui/icons-material/Help';
import QuizIcon from '@mui/icons-material/Quiz';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import PermDataSettingIcon from '@mui/icons-material/PermDataSetting';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import BikeScooterIcon from '@mui/icons-material/BikeScooter';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WorkIcon from '@mui/icons-material/Work';
import VerifiedIcon from '@mui/icons-material/Verified';
import ViewSidebarIcon from '@mui/icons-material/ViewSidebar';
import ListIcon from '@mui/icons-material/List';
import BusinessIcon from '@mui/icons-material/Business';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import SummarizeIcon from '@mui/icons-material/Summarize';
import StarsIcon from '@mui/icons-material/Stars';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import ReceiptIcon from '@mui/icons-material/Receipt';
import GppGoodIcon from '@mui/icons-material/GppGood';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import ApprovalIcon from '@mui/icons-material/Approval';
import GppBadIcon from '@mui/icons-material/GppBad';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import SellIcon from '@mui/icons-material/Sell';
import SavingsIcon from '@mui/icons-material/Savings';
import PaymentIcon from '@mui/icons-material/Payment';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ShareIcon from '@mui/icons-material/Share';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import DiscountIcon from '@mui/icons-material/LocalOffer';
import DraftsIcon from '@mui/icons-material/Drafts';
import GroupsIcon from '@mui/icons-material/Groups';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import WhereToVoteIcon from '@mui/icons-material/WhereToVote';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import FormatIndentIncreaseIcon from '@mui/icons-material/FormatIndentIncrease';
import AttributionIcon from '@mui/icons-material/Attribution';
import SubtitlesIcon from '@mui/icons-material/Subtitles';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import EmailTwoToneIcon from '@mui/icons-material/EmailTwoTone';
import DescriptionIcon from '@mui/icons-material/Description';
import AssignmentIcon from '@mui/icons-material/Assignment';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
export interface MenuItem {
  link?: string;
  icon?: ReactNode;
  badge?: string;
  items?: MenuItem[];
  name: string;
}
export interface MenuItems {
  items: MenuItem[];
  heading: string;
}
let allowedMenus = [];
var userDatas = JSON.parse(localStorage.getItem('userDatas'));
if (userDatas && userDatas.userData.role != null) {
  const permissions = userDatas.userData.role.permissions;
  for (const permission of permissions) {
    if (permission.features && permission.features.name === 'Side Menu') {
      allowedMenus.push(permission.action);
    }
  }
  console.log('allowedMenus', allowedMenus);
}
const menuItems: MenuItems[] = [
  {
    heading: '',
    items: [
      {
        name: 'Dashboard',
        link: `/${RouteKeys.Dashboard}/dashboard`,
        icon: DashboardIcon
      }
    ]
  },
  {
    heading: '',
    items: [
      {
        name: 'CRM',
        icon: AddToQueueIcon,
        link: '',
        items: [
          {
            name: 'Corporate Customers',
            icon: CorporateFareIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.CorporateCustomers}`
          },
          {
            name: 'Retail Customers',
            icon: SupervisedUserCircleIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Customer}`
          },
          {
            name: 'Enquiries',
            icon: BorderColorIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Enquiries}`
          },
          // {
          //   name: 'Requirements',
          //   icon: CardMembershipIcon,
          //   link: `/${RouteKeys.Dashboard}/${RouteKeys.Requirements}`
          // },
          {
            name: 'Customer Leads',
            icon: SupervisedUserCircleIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Leads}`
          },
          {
            name: 'RFQs',
            icon: RequestQuoteIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Rfq}`
          },
          {
            name: 'QC Approval',
            icon: VerifiedIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.QcApproval}`
          },
          {
            name: 'RFQ Placement to Insurer',
            icon: DvrIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Placement}`
          },
          {
            name: 'Offers',
            icon: StarsIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Offers}`
          },
          {
            name: 'Placement Slips',
            icon: ReceiptIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.PlacementSlip}`
          },
          {
            name: 'Policies',
            icon: GppGoodIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Policies}`
          },
          {
            name: 'Update Co-Insurance Details',
            icon: GroupsIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.UpdateCoInsurance}`
          },
          {
            name: 'Endorsement',
            icon: FactCheckIcon,
            link: ` `,
            items: [
              {
                name: 'Endorsement List',
                icon: FactCheckIcon,
                link: `/${RouteKeys.Dashboard}/${RouteKeys.Endorsement}`
              },
              {
                name: 'Share Endorsement',
                icon: ShareIcon,
                link: `/${RouteKeys.Dashboard}/${RouteKeys.EndorsementShareList}`
              },
              {
                name: 'Policy QC Drafts',
                icon: DraftsIcon,
                link: `/${RouteKeys.Dashboard}/${RouteKeys.EndorsementDraftShareList}`
              }
            ]
          },

          {
            name: 'Policy Renewals',
            icon: AutorenewIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.PolicyRenewal}`
          },
          // {
          //   name: 'Orders',
          //   icon: DvrIcon,
          //   link: `/${RouteKeys.Dashboard}/${RouteKeys.Orders}`
          // },
          // {
          //   name: 'Policies',
          //   icon: HealthAndSafetyIcon,
          //   link: `/${RouteKeys.Dashboard}/${RouteKeys.Policies}`
          // },
          // {
          //   name: 'Claim',
          //   icon: PolicyIcon,
          //   link: ` `,
          //   items: [
          //     {
          //       name: 'Claims',
          //       icon: PolicyIcon,
          //       link: `/${RouteKeys.Dashboard}/${RouteKeys.PolicyClaims}`
          //     },
          //     {
          //       name: 'Claim Templates',
          //       icon: PolicyIcon,
          //       link: `/${RouteKeys.Dashboard}/${RouteKeys.ClaimTemplates}`
          //     },
          //     {
          //       name: 'Claims-QC',
          //       icon: PolicyIcon,
          //       link: `/${RouteKeys.Dashboard}/${RouteKeys.PolicyClaimsQC}`
          //     }
          //   ]
          // },
          {
            name: 'Organogram',
            icon: ConnectWithoutContactIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Organogram}`
          }
        ]
      }
    ]
  },
  {
    heading: '',
    items: [
      {
        name: 'Claim',
        icon: DescriptionIcon,
        link: ` `,
        items: [
          {
            name: 'Claims',
            icon: AssignmentIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.PolicyClaims}`
          },
          {
            name: 'Claim Templates',
            icon: FileCopyIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.ClaimTemplates}`
          },
          {
            name: 'Claims-QC',
            icon: CheckCircleIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.PolicyClaimsQC}`
          }
        ]
      }
    ]
  },
  {
    heading: '',
    items: [
      {
        name: 'Users',
        icon: SupervisedUserCircleIcon,
        link: `/${RouteKeys.Dashboard}/${RouteKeys.Users}`
      }
    ]
  },

  {
    heading: '',
    items: [
      {
        name: 'Insurance Settings',
        icon: ReceiptLongIcon,
        link: '',

        items: [
          {
            name: 'Master Categories',
            icon: ViewSidebarIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Master}`
          },
          {
            name: 'Categories',
            icon: ListIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.InsuranceType}`
          },
          {
            name: 'Endorsement Sub Types',
            icon: ApprovalIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.EndoresementSubTypes}`
          },
          {
            name: 'Products',
            icon: BorderColorIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.PolicyProducts}`
          },
          {
            name: 'LOR/LOD',
            icon: BorderColorIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.PolicyLod}`
          },
          // {
          //   name: 'Risk Factor Settings',
          //   icon: PermDataSettingIcon,
          //   link: '',
          //   items: [
          //     {
          //       name: 'Occupancies',
          //       icon: StoreIcon,
          //       link: `/${RouteKeys.Dashboard}/${RouteKeys.Occupancy}`
          //     },
          //     {
          //       name: 'Machine Types',
          //       icon: PrecisionManufacturingIcon,
          //       link: `/${RouteKeys.Dashboard}/${RouteKeys.MachineType}`
          //     },
          //     {
          //       name: 'Voyages',
          //       icon: DirectionsBoatIcon,
          //       link: `/${RouteKeys.Dashboard}/${RouteKeys.Voyage}`
          //     },
          //     {
          //       name: 'Vehicle Types',
          //       icon: BikeScooterIcon,
          //       link: `/${RouteKeys.Dashboard}/${RouteKeys.VehichleType}`
          //     },
          //     {
          //       name: 'Product Rates',
          //       icon: MonetizationOnIcon,
          //       link: `/${RouteKeys.Dashboard}/${RouteKeys.ProductRate}`
          //     },
          //     {
          //       name: 'Occupations',
          //       icon: WorkIcon,
          //       link: `/${RouteKeys.Dashboard}/${RouteKeys.Occupation}`
          //     },
          //     {
          //       name: 'Ages',
          //       icon: RotateLeftIcon,
          //       link: `/${RouteKeys.Dashboard}/${RouteKeys.AgeSettingsList}`
          //     },
          //     {
          //       name: 'Sections',
          //       icon: ViewModuleIcon,
          //       link: `/${RouteKeys.Dashboard}/${RouteKeys.SectionSettingsList}`
          //     },
          //     {
          //       name: 'Others',
          //       icon: SettingsApplicationsIcon,
          //       link: `/${RouteKeys.Dashboard}/${RouteKeys.OthersSettingsList}`
          //     }
          //   ]
          // },
          {
            name: 'Insurance Companies',
            icon: BusinessIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.InsuranceComapny}`
          },
          {
            name: 'TPA',
            icon: AddBusinessIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.ThirdPartyAdministrator}`
          },

          {
            name: 'Coverages & Clauses',
            icon: ReportGmailerrorredIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.InsuranceClause}`
          },
          {
            name: 'Industries',
            icon: AccountBalanceIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Industry}`
          },

          {
            name: 'Insurance Zone Categories',
            icon: CategoryIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.InsuranceCategoryZone}`
          },
          {
            name: 'Insurance Zones',
            icon: PlaceIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.InsuranceZone}`
          },
          {
            name: 'Insurance Wallet',
            icon: PlaceIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.InsuranceCompanyWallet}`
          }
        ]
      }
    ]
  },
  // {
  //   heading: '',
  //   items: [
  //     {
  //       name: 'Sum Insured Settings',
  //       icon: PermDataSettingIcon,
  //       link: '',

  //       items: [
  //         {
  //           name: 'Occupancies',
  //           icon: StoreIcon,
  //           link: `/${RouteKeys.Dashboard}/${RouteKeys.Occupancy}`
  //         }
  //         // {
  //         //   name: 'Machine Types',
  //         //   icon: PrecisionManufacturingIcon,
  //         //   link: `/${RouteKeys.Dashboard}/${RouteKeys.MachineType}`
  //         // },
  //         // {
  //         //   name: 'Voyages',
  //         //   icon: DirectionsBoatIcon,
  //         //   link: `/${RouteKeys.Dashboard}/${RouteKeys.Voyage}`
  //         // },
  //         // {
  //         //   name: 'Vehicle Types',
  //         //   icon: BikeScooterIcon,
  //         //   link: `/${RouteKeys.Dashboard}/${RouteKeys.VehichleType}`
  //         // },
  //         // {
  //         //   name: 'Product Rates',
  //         //   icon: MonetizationOnIcon,
  //         //   link: `/${RouteKeys.Dashboard}/${RouteKeys.ProductRate}`
  //         // },
  //         // {
  //         //   name: 'Occupations',
  //         //   icon: WorkIcon,
  //         //   link: `/${RouteKeys.Dashboard}/${RouteKeys.Occupation}`
  //         // }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   heading: '',
  //   items: [
  //     {
  //       name: 'Scores',
  //       icon: AppRegistrationIcon,
  //       link: `/${RouteKeys.Dashboard}/${RouteKeys.Scores}`
  //     }
  //   ]
  // },
  {
    heading: '',
    items: [
      {
        name: 'History',
        icon: LibraryBooksIcon,
        link: `/${RouteKeys.Dashboard}/${RouteKeys.EventLog}`
      }
    ]
  },
  {
    heading: '',
    items: [
      {
        name: 'Mail Log',
        icon: ForwardToInboxIcon,
        link: `/${RouteKeys.Dashboard}/${RouteKeys.MailLog}`
      }
    ]
  },

  {
    heading: '',
    items: [
      {
        name: 'Master Settings',
        icon: AddBusinessIcon,
        link: '/management/profile',

        items: [
          {
            name: 'Branches',
            icon: AccountTreeIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Branch}`
          },

          {
            name: 'Departments',
            icon: DeveloperBoardIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Department}`
          },

          {
            name: 'IP - Settings',
            icon: BlockIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.BlockIP}`
          },
          {
            name: 'States',
            icon: EditLocationIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.States}`
          },
          {
            name: 'Districts',
            icon: MyLocationIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.District}`
          },
          {
            name: 'Vehicle Make',
            icon: VehicleIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.VehicleMake}`
          },
          {
            name: 'Stages - Leads',
            icon: GradingIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Stages}`
          },
          {
            name: 'Dynamic Configurations',
            icon: DynamicFeedIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.DynamicConfigurations}`
          },
          {
            name: 'Holiday Settings',
            icon: TodayIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Holidays}`
          },
          {
            name: 'Newsletters',
            icon: LibraryBooksIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.NewsletterSettings}`
          },
          {
            name: 'Document Names',
            icon: LibraryBooksIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.DocumentNames}`
          },
          {
            name: 'RFQ Cancel Reasons',
            icon: GppBadIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.RfqCancelReason}`
          },
          {
            name: 'Customer Group',
            icon: GroupAddIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.CustomerGroup}`
          },
          {
            name: 'Claims TPA',
            icon: ContactPageIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.ClaimTpa}`
          },

          {
            name: 'Claims Surveyor Type',
            icon: FormatIndentIncreaseIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.ClaimSurveyorType}`
          },
          {
            name: 'Claims Surveyor',
            icon: AttributionIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.ClaimSurveyor}`
          },

          {
            name: 'Claims Sub Type',
            icon: SubtitlesIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.ClaimSubType}`
          },
          {
            name: 'Hospitals',
            icon: LocalHospitalIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Hospital}`
          },
          {
            name: 'Rejection Reason',
            icon: ThumbDownIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.RejectionReason}`
          },
          {
            name: 'Currency',
            icon: AttachMoneyIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Currency}`
          },
          {
            name: 'Email Master',
            icon: EmailTwoToneIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.EmailMaster}`
          },

          {
            name: 'Questionnaire',
            icon: QuizIcon,
            link: '',
            items: [
              {
                name: 'Questions',
                icon: HelpIcon,
                link: `/${RouteKeys.Dashboard}/${RouteKeys.Questions}`
              },
              {
                name: 'Questionnaire',
                icon: QuestionAnswerIcon,
                link: `/${RouteKeys.Dashboard}/${RouteKeys.Questionnaire}`
              },
              {
                name: 'Assessments',
                icon: AssessmentIcon,
                link: `/${RouteKeys.Dashboard}/${RouteKeys.Assessments}`
              },

              {
                name: 'Assessments Summary',
                icon: SummarizeIcon,
                link: `/${RouteKeys.Dashboard}/${RouteKeys.AssessmentsSummaryList}`
              }
            ]
          },
          {
            name: 'CMS',
            icon: MiscellaneousServicesIcon,
            link: '',
            items: [
              {
                name: 'Categories',
                icon: FormatAlignJustifyIcon,
                link: `/${RouteKeys.Dashboard}/${RouteKeys.Category}`
              },
              {
                name: 'Sub Categories',
                icon: FormatListBulletedIcon,
                link: `/${RouteKeys.Dashboard}/${RouteKeys.Subcategory}`
              },
              {
                name: 'Article',
                icon: ArticleRoundedIcon,
                link: `/${RouteKeys.Dashboard}/${RouteKeys.Article}`
              }
            ]
          },
          {
            name: 'Surveyors',
            icon: ManageAccountsIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Surveyor}`
          },
          {
            name: 'Banks',
            icon: AccountBalanceOutlinedIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Bank}`
          },
          {
            name: 'Excess/Deductible',
            icon: DiscountIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.ExcessDeductible}`
          }
        ]
      }
    ]
  },
  {
    heading: '',
    items: [
      {
        name: 'Forms Management',
        icon: SchemaIcon,
        link: '',
        items: [
          {
            name: 'Master Input Fields',
            icon: DynamicFormIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.MasterInputFields}`
          },

          {
            name: 'Claims-Field Master',
            icon: TextFieldsIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.FieldMaster}`
          },
          {
            name: 'Claims-Master Data',
            icon: WhereToVoteIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.MasterData}`
          }
          // {
          //   name: 'Forms',
          //   icon: TableViewIcon,
          //   link: `/${RouteKeys.Dashboard}/${RouteKeys.Forms}`
          // }
          // {
          //   name: 'Workflows',
          //   icon: InsightsIcon,
          //   link: `/${RouteKeys.Dashboard}/${RouteKeys.Workflows}`
          // },
          // {
          //   name: 'Workflow mapping ',
          //   icon: AcUnitIcon,
          //   link: `/${RouteKeys.Dashboard}/${RouteKeys.WorkflowMapping}`
          // }
        ]
      }
    ]
  },
  {
    heading: '',
    items: [
      {
        name: 'Finance Reports',
        icon: SellIcon,
        link: '',
        items: [
          {
            name: 'Brokerage',
            icon: ReceiptIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Brokerage}`
          },
          {
            name: 'Reward',
            icon: SavingsIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Reward}`
          },
          {
            name: 'Tax Slab Settings',
            icon: PointOfSaleIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.Tax}`
          },
          {
            name: 'TDS',
            icon: PaymentIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.TDS}`
          },
          {
            name: 'Tax Period Settings',
            icon: AccessTimeIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.TaxPeriodSetting}`
          },
          {
            name: 'Brokerage Reconciliation',
            icon: ReceiptIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.BrokerageReconciliation}`
          },
          {
            name: 'Brokerage Adjustment Endorsement',
            icon: ReceiptIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.BrokerageAdjustmentEndorsement}`
          }
        ]
      }
    ]
  },
  {
    heading: '',
    items: [
      {
        name: 'Reports',
        icon: SellIcon,
        link: '',
        items: [
          {
            name: 'MIS Report',
            icon: ReceiptIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.MisReport}`
          },
          {
            name: 'MIS Report BR',
            icon: ReceiptIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.MisReport1}`
          },
          {
            name: 'MIS Report WB',
            icon: ReceiptIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.MisReport2}`
          },
          {
            name: 'Leads Report',
            icon: ReceiptIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.LeadsReport}`
          },
          {
            name: 'Invoicing Report',
            icon: ReceiptIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.InvoicingReport}`
          },
          {
            name: 'Invoice Status Report',
            icon: ReceiptIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.InvoiceStatusReport}`
          },
          {
            name: 'Placement Report 1',
            icon: DescriptionIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.PlacementReport}`
          },
          {
            name: 'Placement Report 2',
            icon: DescriptionIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.PlacementReportTwo}`
          },
          {
            name: 'Policy Status Report',
            icon: DescriptionIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.PolicyStatusReport}`
          },
          {
            name: 'Endorsement Status Report',
            icon: DescriptionIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.EndorsementStatusReport}`
          },
          {
            name: 'Policy Report 1',
            icon: DescriptionIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.PolicyReportOne}`
          },
          {
            name: 'Policy Report 2',
            icon: DescriptionIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.PolicyReportTwo}`
          },
          {
            name: 'Policy Renewal Report',
            icon: DescriptionIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.PolicyRenewalReport}`
          },
          {
            name: 'IRDAI Report',
            icon: DescriptionIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.IrdaiForms}`
          },
          {
            name: 'Invoice Receivable Report',
            icon: DescriptionIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.InvoiceReceivable}`
          },
          {
            name: 'Invoice GST Report',
            icon: DescriptionIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.InvoiceGstReport}`
          },

          {
            name: 'Transaction Wise Receivable Report',
            icon: DescriptionIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.TransactionWiseReceivableReport}`
          },
          {
            name: 'Business Report',
            icon: DescriptionIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.BusinessReport}`
          },
          {
            name: 'Business BR Report',
            icon: DescriptionIcon,
            link: `/${RouteKeys.Dashboard}/${RouteKeys.BusinessBRReport}`
          }
        ]
      }
    ]
  }
];
if (allowedMenus.length > 0 && userDatas.userData.userType !== 'SuperAdmin') {
  for (const menu of menuItems) {
    const i = menuItems.indexOf(menu);
    let mainMenuItems = menu.items;

    for (const subList of mainMenuItems) {
      const index = mainMenuItems.indexOf(subList);
      if (subList.items && subList.items.length > 0) {
        let subListItems = subList.items;
        let itemsForDelete = [];
        let lengthOfSubListItems = null;
        // console.log('beforesubListItems', subListItems);
        const newArray = [];
        for (const items of subListItems) {
          const subindex = subListItems.indexOf(items);
          lengthOfSubListItems = subListItems.length;

          // subListItems.splice(1, 1);

          if (!allowedMenus.includes(items.name)) {
            itemsForDelete.push(subindex);
            //  subListItems.splice(3, 1);
            // console.log('itemsForDelete',items);
          } else {
            newArray.push(items);
          }
        }
        if (lengthOfSubListItems == itemsForDelete.length) {
          mainMenuItems.splice(index, 1);
        } else {
          if (menuItems[i]) {
            menuItems[i]['items'][index]['items'] = newArray;
          }

          subListItems = newArray;
        }
        // console.log("newArray",newArray);

        // console.log('newArray',newArray)
        // console.log('aftersubListItems',subListItems)
        // console.log('itemsForDelete',itemsForDelete)
      } else {
        // console.log('subList.name',subList.name)
        if (!allowedMenus.includes(subList.name)) {
          mainMenuItems.splice(index, 1);
          // mainMenuItems.pop();
        }
      }
    }
  }

  menuItems.forEach(function (menu, i) {
    // console.log('%d: %s', i, menu);
    let mainMenuItems = menu.items;
    for (const subList of mainMenuItems) {
      // const index = mainMenuItems.indexOf(subList);
      if (subList.items && subList.items.length <= 0) {
        menuItems.splice(i, 1);
      }
    }
  });
  const FinalMenus = [];
  menuItems.forEach((menuItem) => {
    if (menuItem.items.length > 0) {
      FinalMenus.push(menuItem);
    }
  });
  menuItems.splice(0, menuItems.length, ...FinalMenus);

  // for  (const menu of menuItems) {
  //   const i = menuItems.indexOf(menu);
  //   console.log('mainMenu',menu)
  //   let mainMenuItems = menu.items;
  //   console.log('mainMenuItems',mainMenuItems)
  //   console.log('length',mainMenuItems.length)

  //   if (mainMenuItems.length == 0) {
  //     menuItems.splice(i, 1);
  //   }
  // }
} else if (userDatas && userDatas.userData.userType !== 'SuperAdmin') {
  menuItems.splice(0, menuItems.length);
}
let admin_window = localStorage.getItem('admin_window');

let menuItemBeforFilter = [...menuItems];
let menuItemAfterFilter = [];
console.log('menuItemBeforFilter', menuItemBeforFilter);
for (const menu of menuItemBeforFilter) {
  const i = menuItems.indexOf(menu);
  let mainMenuItems = menu.items;
  if (
    userDatas?.userData?.userType == 'Admin' &&
    userDatas?.userData?.activeBranchData?.userType == 'Admin'
  ) {
    if (
      admin_window &&
      admin_window == 'insuranceAdmin' &&
      mainMenuItems[0].name !== 'Master Settings'
    ) {
      menuItemAfterFilter.push(menu);
    }
    if (
      admin_window &&
      admin_window == 'SystemAdmin' &&
      (mainMenuItems[0].name == 'Master Settings' ||
        mainMenuItems[0].name == 'Dashboard')
    ) {
      menuItemAfterFilter.push(menu);
    }
  }
}
if (
  userDatas?.userData?.userType != 'Admin' ||
  userDatas?.userData?.activeBranchData?.userType != 'Admin'
) {
  menuItemAfterFilter = [...menuItems];
}

export default menuItemAfterFilter;
